import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { RouterModule } from '@angular/router';
import { AcademyCommonModule } from '@draeger-academy/common';
import { AcademyPresentationUiModule } from '@draeger-academy/presentation';
import { LocalizeRouterModule } from '@gilsdav/ngx-translate-router';
import { TranslateModule } from '@ngx-translate/core';
import { OrderProcessModule } from './modules/order-process/order-process.module';
import { PartnerPortalModule } from './partner-portal.module';
import { PortalAppComponent } from './portal-app.component';
import { portalAppRoutes } from './portal-app.routes';

@NgModule({
    declarations: [PortalAppComponent],
    imports: [
        CommonModule,
        AcademyCommonModule,
        AcademyPresentationUiModule,
        PartnerPortalModule,
        //please do not change the order of the next 3 imports
        TranslateModule,
        RouterModule.forChild(portalAppRoutes),
        LocalizeRouterModule.forChild(portalAppRoutes)
    ],
    exports: [PortalAppComponent]
})
export class PortalAppModule {}
